import React from 'react';

function Career() {
  // Sample job positions
  const positions = [
    { title: "Frontend Developer", location: "Remote / India", type: "Full-time", link: "#" },
    { title: "Backend Developer", location: "Remote / India", type: "Full-time", link: "#" },
    { title: "UI/UX Designer", location: "Remote / India", type: "Contract", link: "#" },
    { title: "AI/ML Engineer", location: "Remote / India", type: "Full-time", link: "#" },
  ];


  return (
    <div>
      {/* Hero Section */}
      <div className="container-fluid pt-5 bg-primary hero-header">
        <div className="container pt-5">
          <div className="row g-5 pt-5 align-items-center">
            <div className="col-lg-6 text-center text-lg-start mb-lg-5">
              <h1 className="display-4 text-white mb-4 animated slideInRight">Careers at Blue Vipers</h1>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb justify-content-center justify-content-lg-start mb-0">
                  <li className="breadcrumb-item"><a className="text-white" href="/">Home</a></li>
                  <li className="breadcrumb-item text-white active" aria-current="page">Careers</li>
                </ol>
              </nav>
              <p className="text-white-50 mt-3">
                Join our team of innovators and contribute to cutting-edge AI, software, and digital solutions. We value talent, creativity, and collaboration.
              </p>
            </div>
            <div className="col-lg-6 text-center text-lg-end">
              <img className="img-fluid" src="assets/img/hero-img.png" alt="Career Hero" style={{ maxHeight: 300 }} />
            </div>
          </div>
        </div>
      </div>

      {/* Open Positions Section */}
      <div className="container py-5">
        <div className="text-center mb-5">
          <div className="btn btn-sm border rounded-pill text-primary px-3 mb-3">Open Positions</div>
          <h1 className="mb-4">Join Our Team</h1>
          <p className="text-muted mb-5">
            We are looking for passionate and talented individuals to join our team. Explore our current openings below and take the next step in your career with us!
          </p>
        </div>
        <div className="row g-4">
          {positions.map((job, idx) => (
            <div key={idx} className="col-md-6 col-lg-3 wow fadeIn" data-wow-delay={`${0.2 * idx}s`}>
              <div className="card shadow-sm h-100 text-center p-3">
                <h5 className="mb-2">{job.title}</h5>
                <p className="mb-1">{job.location}</p>
                <small className="text-muted">{job.type}</small>
                <a href="tel:+918459432930" className="btn btn-success mt-3">Call Now </a>
              </div>
            </div>
          ))}
        </div>
      </div>


      {/* Contact Section */}
      <div className="container-fluid bg-primary py-5">
        <div className="container text-center text-white">
          <h2 className="mb-3">Ready to Join Us?</h2>
          <p className="mb-1">Call us at <strong>+91 8459432930</strong></p>
          <p className="mb-4">Or email us at <strong>blueviperstechnology@gmail.com</strong></p>
          <a href="tel:+918459432930" className="btn btn-light rounded-pill px-4 py-2">Call Now </a>
        </div>
      </div>
    </div>
  );
}

export default Career;
